import { BackofficeLayout } from '@/components/layout/BackofficeLayout'
import { StatRow } from '@/components/backoffice/StatRow'
import { DataTable } from '@/components/backoffice/DataTable'
import { SectionHeader } from '@/components/backoffice/SectionHeader'
import { Badge } from '@/components/ui/badge'
import { BackofficeDashboardStats, BackofficeFormation } from '@/types'

type Props = {
  stats: BackofficeDashboardStats
  recent_formations: BackofficeFormation[]
}

const stageVariant: Record<string, 'default' | 'secondary' | 'outline'> = {
  application: 'outline',
  filing: 'secondary',
  completed: 'default',
}

export default function DashboardShow({ stats, recent_formations }: Props) {
  return (
    <BackofficeLayout title="Dashboard">
      <div className="space-y-8">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Dashboard</h1>
          <p className="text-sm text-muted-foreground">Platform overview and recent activity</p>
        </div>

        <StatRow stats={[
          { label: 'formations', value: stats.total_formations },
          { label: 'in progress', value: stats.active_formations },
          { label: 'completed', value: stats.completed_formations },
          { label: 'entities', value: stats.total_entities },
          { label: 'staff', value: stats.total_staff },
        ]} />

        <div>
          <SectionHeader title="Recent Formations" count={recent_formations.length} />
          <DataTable
            data={recent_formations}
            keyFn={f => f.id}
            emptyMessage="No formations yet. They'll appear here as users create them."
            columns={[
              { key: 'name', header: 'Name', className: 'flex-1 min-w-0', render: f => (
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{f.legal_name}</p>
                  <p className="text-[12px] text-muted-foreground truncate">{f.entity_name}</p>
                </div>
              )},
              { key: 'account', header: 'Account', className: 'w-40', render: f => (
                <span className="text-sm text-muted-foreground">{f.account_name}</span>
              )},
              { key: 'stage', header: 'Stage', className: 'w-28', render: f => (
                <Badge variant={stageVariant[f.stage] || 'outline'} className="text-[11px] capitalize">
                  {f.stage.replace(/_/g, ' ')}
                </Badge>
              )},
            ]}
          />
        </div>
      </div>
    </BackofficeLayout>
  )
}
